<template>
  <div class="dynamics">
    <div class="maxbox dynamics_bigbox w1200">
      <div class="leftBox">
        <div class="dynamics_box_title">对接动态</div>
        <p>
         需求方发布的生产、经营等需求，通过平台对接、撮合，供需双方快速匹配，实现资源互补、合作共赢
        </p>
        <!-- <el-button type="primary">了解详情</el-button> -->
      </div>
      <div class="dynamics_scroll">
        <vue-seamless-scroll :data="dynamicsList" :class-option="defaultOption">
          <div class="dynamics_box">
            <div class="dynamics_box_r" v-for="(item,index) in dynamicsList" :key="index">
              <img :src="require(`../../assets/supplyHome/${item.state}.png`)" alt="" class="dynamics_box_icon">
              <div class="box_r_com">
                <div style="margin-right: 18px">
                  <p class="box_r_name">
                    <img src="../../assets/supplyHome/xu.png" alt=""  style="width:22px;">
                    <span>{{item.buyer_name}}</span>
                  </p>
                  <p class="box_r_name">
                    <img src="../../assets/supplyHome/gong.png" alt="" style="width:22px;">
                    <span>{{item.enterprise_name}}</span>
                  </p>
                </div>
                <img src="../../assets/supplyHome/dynamicsJT.png" alt="" />
              </div>
              <div class="box_r_mesg">
                <p class="box_r_mesgName">意向金额</p>
                <p class="box_r_money">{{item.offer_price}}元</p>
              </div>
            </div>
          </div>
        </vue-seamless-scroll>
      </div>
    </div>
  </div>
</template>

<script>
import {duijieQuery} from "../../utils/interface";

export default {
  data() {
    return {
      dynamicsList: []
    };
  },
   computed: {
    defaultOption () {
      return {
        step: 0.3, // 数值越大速度滚动越快
        // limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        // hoverStop: true, // 是否开启鼠标悬停stop
        // direction: 1, // 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        // singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        // singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        // waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }

  },
  created() {
    this.duijieQueryList();
  },
  methods:{
    duijieQueryList(){
      console.log("-------------duijieQueryList------------------")
      duijieQuery({}).then((res)=>{
        this.dynamicsList = res.list;
      })
    }
  }
};
</script>

<style lang="less" scoped>
.maxbox {
  width: 1200px;
  margin: 0 auto;
}
.dynamics {
  background: url("../../assets/supplyHome/dynamicsbanner.png") no-repeat;
  background-size: 100% 100%;
  height: 467px;
  padding-top: 40px;
  overflow: hidden;
  .dynamics_bigbox {
    display: flex;
    overflow: hidden;
    .leftBox {
      color: #fff;
      width: 270px;
      margin-right: 73px;
      margin-top: 101px;
      .dynamics_box_title {
        font-weight: 500;
        font-size: 26px;
        width: 303px;
        flex-shrink: 0;
      }
      p {
        font-size: 14px;
        margin: 29px 0 51px;
        line-height: 24px;
      }
    }
    .dynamics_scroll {
      overflow: hidden;
      height: 430px;
    }

    .dynamics_box {
      display: grid;
      grid-template-columns: 376px 376px;
      grid-column-gap: 24px;
      .dynamics_box_r {
        background: url("../../assets/supplyHome/dynamicsBox.png") no-repeat;
        background-size: 100% 100%;
        border-radius: 8px;
        color: #fff;
        padding: 29px 0 0 24px;
        height: 200px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 24px;
        .dynamics_box_icon {
          position: absolute;
          top: 0;
          right: 0;
        }
        .box_r_com {
          display: flex;
          align-items: center;
          line-height: 52px;
          .box_r_name {
            font-size: 18px;
            display: flex;
            align-items: center;
            img {
              width: 22px;
              margin-right: 5px;
            }
            i {
              margin-right: 3px;
            }
            span {
              flex-wrap: wrap;
            }
          }
          span {
            font-size: 14px;
          }
        }
        .box_r_mesg {
          display: flex;
          align-items: baseline;
          margin-top: 5px;
          margin-left: 27px;
          .box_r_mesgName {
            font-size: 14px;
            margin-right: 8px;

          }
          .box_r_money {
            font-size: 22px;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/dynamics.vue